import { useAppStore } from '@/stores/app';

export const ButtonMute = () => {
  const muted = useAppStore((state) => state.muted);
  const toggleMuted = useAppStore((state) => state.toggleMuted);

  return (
    <button
      className={cn(
        'pointer-events-auto fixed top-3 right-3 z-10 h-[4rem] w-[4rem]',
        'texture-beige border border-2 border-black'
      )}
      onClick={() => toggleMuted()}
    >
      {!muted ? (
        <img
          src="/assets/images-next/sound-on.webp"
          className="center-img max-w-[70%]"
        />
      ) : (
        <img
          src="/assets/images-next/sound-off.webp"
          className="center-img max-w-[70%]"
        />
      )}
    </button>
  );
};
